// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__VNlqw","paramInput":"JobSimulator_paramInput__29XW-","input":"JobSimulator_input__mM5xU"};